import React from 'react';
import { WithInfiniteOptions } from '../HOCs/WithInfiniteList';
import Select from '../Select/index';
import { useCreate } from 'context/ResourceProvider/hooks/useCreate';

const SelectWithCreatable = WithInfiniteOptions(Select);

const TestItemSelect = ({ countryId, onCreate, ...rest }) => {
  const handleSearch = (keywords, options) => {
    let others = [];
    let relatedSource = [];
    let result = [];
    if (Array.isArray(options)) {
      others = others.concat(
        options.map((data) => {
          const { id, name, citationList } = data;
          return {
            value: id,
            label: `${name}, ${citationList ? citationList.name : ''}`,
            data,
          };
        })
      );
    }
    if (Array.isArray(related)) {
      relatedSource = related.filter((option) =>
        option.label.toLowerCase().includes(keywords?.toLowerCase())
      );
    }
    if (related.length) {
      result = [
        {
          key: 'related',
          label: 'Related Test Item & Citation',
          title: 'Related Test Item & Citation',
          options: relatedSource,
        },
      ];
    }
    if (others.length) {
      result.push({
        key: 'others',
        label: 'Others',
        title: 'Others',
        options: others,
      });
    }
    return result;
  };

  return (
    <SelectWithCreatable
      resource="test_items"
      filters={{ countryListId: countryId }}
      pagination={{ current: 1, pageSize: 9999 }}
      transformOptions={(options) => {
        const grouped = [];
        const relatedSource = options.filter((option) => option.sourceType === 'compliance');
        const otherSource = options.filter((option) => option.sourceType === 'custom');
        const transformOption = (data) => {
          const { id, name, citationList } = data;
          return {
            value: id,
            label: `${name}, ${citationList?.name || ''}`,
            data,
          };
        };
        if (relatedSource.length) {
          grouped.push({
            key: 'related',
            label: 'Related',
            title: 'Related',
            options: relatedSource.map(transformOption),
          });
        }
        if (otherSource.length) {
          grouped.push({
            key: 'others',
            label: 'Others',
            title: 'Others',
            options: otherSource.map(transformOption),
          });
        }

        return grouped;
      }}
      showArrow
      allowClear
      skip={!countryId}
      onCreate={
        onCreate
          ? (...rest) => {
              onCreate(...rest, countryId);
            }
          : undefined
      }
      {...rest}
    />
  );
};

export default TestItemSelect;
